import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Icons from '../../constants/Icons'
import { Link, Route } from 'react-router-dom'

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className='site-footer wpex-surface-dark'>
      <Container className='footer-container'>
        <Col className='footer-box'>
          {/* <img
            onClick={scrollToTop}
            width='300'
            height='300'
            src={Icons.logo}
            alt='Logo'
            style={{ maxWidth: '100%', height: 'auto', cursor: 'pointer' }}
          /> */}

          {/* <div>
            <ul>
              {[
                {
                  href: 'https://www.facebook.com/TravelportGlobal/',
                  icon: 'facebook'
                },
                { href: 'https://twitter.com/travelport/', icon: 'twitter' },
                {
                  href: 'https://www.linkedin.com/company/travelport',
                  icon: 'linkedin'
                },
                {
                  href: 'https://www.youtube.com/TravelportTube',
                  icon: 'youtube-play'
                },
                {
                  href: 'https://www.instagram.com/travelportofficial',
                  icon: 'instagram'
                }
              ].map((social, index) => (
                <li key={index}>
                  <a
                    href={social.href}
                    target='_blank'
                    rel='noopener noreferrer'
                    className={`wpex-${social.icon} wpex-social-btn wpex-social-btn-black wpex-hover-opacity-80 wpex-round`}
                  >
                    <span
                      className={`ticon ticon-${social.icon}`}
                      aria-hidden='true'
                    ></span>
                  </a>
                </li>
              ))}
            </ul>
          </div> */}
        </Col>
      </Container>
      <div
        style={{
          borderTop: '0.2px solid #f8ac19',
          padding: '20px',
          marginTop: '30px'
        }}
      >
        <Row>
          {[
            {
              title: 'Connect With Us',
              links: [
                {
                  href: 'mailto:info@arrshiyanatravels.com',
                  text: 'info@arrshiyanatravels.com'
                }
              ]
            },
            {
              title: 'Boarding Call',
              links: [{ href: 'https://api.whatsapp.com/send?phone=918141429290', text: '+91 8141429290' }]
            },
            {
              title: 'Check-in',
              links: [
                {
                  href: 'https://www.arrshiyanatravels.com',
                  text: 'www.arrshiyanatravels.com'
                }
              ]
            },
            {
              title: 'Transit Lounge',
              links: [
                {
                  href: 'https://www.google.com/maps/search/?api=1&query=office+No.106,+1st+Floor,+Rajkiran+Appartment,+New+Jaganath+20%2F22,+Rajkot',
                  text: 'office No.106, 1st Floor, Rajkiran Appartment, New Jaganath 20/22 ,Rajkot'
                }
              ]
            }
          ].map((section, index) => (
            <Col key={index} md={5} className='footer-box'>
              <h5 className='gradient-text'>{section.title}</h5>
              <ul className='menu'>
                {section.links.map((link, idx) => (
                  <li key={idx}>
                    <a href={link.href} target='blank' >{link.text}</a>
                  </li>
                ))}
              </ul>
            </Col>
          ))}
        </Row>
        <Container>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div>
              <b>© 2025 Arrshiyana. All Rights Reserved</b>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  )
}

export default Footer
